import React, {Component} from 'react';
import { Link } from 'react-router-dom';
//import { SelectListComponent } from 'shared-components';
import axios from 'axios';
// const querystring = require('querystring');

export default class UserProjects extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		
	
		this.state = {
"userProjectId": 0,
  "projectName": "",
  "ownerUserId": 0,
  "securityContextId": 0,
  "projectStatusCode": 0,
  "projectTemplateId": 0,
  "userWorkspaceId": 0,
  "targetPortalId": 0,
  "projectDescr": "",
  "projectPath": "",
  "portalPath": "",
  "projectSourcePath": "",
  "projectTargetPath": "",
  "imageSourcePath": "",
  "imageTargetPath": "",
  "effectiveDate": new Date(),
  "expirationDate": new Date(),
  "lastUpdateUser": 0,
  "lastUpdateDate": new Date(),
  "portalXferMode": 0,
  "username": "",
  "password": "",
  "portalServer": "",
  "votes": "",
  "contentId": 0,
  "contentList": "",
  "createUser": 0,
  "createDate": new Date(),
  "pictureFilepath": "",
  "startDate": new Date(),
  "endDate": new Date(),
  "apiKey": "",
  "apiSecret": "",
  "version": "",
  "cloudName": "",
  "workflowId": 0

		};
		this.handleClear = this.handleClear.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	componentDidMount() 
	{
		this.handleOnLoad();
	}

	handleOnLoad = () => {
		this.handleClear()
	}
	handleChange = (event) => {
	}

	handleDelete = (id, event) => {
	}
	handleClear()
	{
		this.state = {
		"userProjectId":0,
  "projectName": "",
  "ownerUserId": 0,
  "securityContextId": 0,
  "projectStatusCode": 0,
  "projectTemplateId": 0,
  "userWorkspaceId": 0,
  "targetPortalId": 0,
  "projectDescr": "",
  "projectPath": "",
  "portalPath": "",
  "projectSourcePath": "",
  "projectTargetPath": "",
  "imageSourcePath": "",
  "imageTargetPath": "",
  "effectiveDate": new Date(),
  "expirationDate": new Date(),
  "lastUpdateUser": 0,
  "lastUpdateDate": new Date(),
  "portalXferMode": 0,
  "username": "",
  "password": "",
  "portalServer": "",
  "votes": "",
  "contentId": 0,
  "contentList": "",
  "createUser": 0,
  "createDate": new Date(),
  "pictureFilepath": "",
  "startDate": new Date(),
  "endDate": new Date(),
  "apiKey": "",
  "apiSecret": "",
  "version": "",
  "cloudName": "",
  "workflowId": 0

		};
	}
	render(){
	return (
	<form>
	<div class="m-content">
	<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
	<div class="container-fluid">
		<h4>Create A Project</h4>
		<hr />

			<h5>General</h5>			
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Name</label>
                        		<input class="form-control input-xlarge col-sm-8" id="projectName" value={this.state.projectName} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Description</label>
                        		<input class="form-control input-xlarge col-sm-8" id="contentInputSourceName" value={this.state.contentInputSourceName} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Owner</label>
                        		<input class="form-control input-xlarge col-sm-8" id="ownerUserId" value={this.state.ownerUserId} onChange={this.handleChange} />
	 			</div>
                        		{/*
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Status Code</label>
					<SelectListComponent IdName="projectStatusCode" onChange={this.handleChange} entityName ={"system-code-values"} 
						valueFilterColumnName = {"systemCodeId"} valueFilter = {"36"} displayColumnName ={"systemCodeValueValue"} 
						keyColumnName ={"systemCodeValueId"} valueId={this.state.contentSourceType} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Template</label>
					<SelectListComponent IdName="projectStatusCode" onChange={this.handleChange} entityName ={"system-code-values"} 
						valueFilterColumnName = {"systemCodeId"} valueFilter = {"37"} displayColumnName ={"systemCodeValueValue"} 
						keyColumnName ={"systemCodeValueId"} valueId={this.state.contentSourceType} />
	 			</div>
					*/}
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Workspace</label>
                        		<input class="form-control input-xlarge col-sm-8" id="userWorkspaceId" value={this.state.userWorkspaceId} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Workflow</label>
                        		<input class="form-control input-xlarge col-sm-8" id="workflowId" value={this.state.workflowId} onChange={this.handleChange} />
	 			</div>

				<h5>Portal</h5>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Target Portal</label>
                        		<input class="form-control input-xlarge col-sm-8" id="contentInputSourceName" value={this.state.contentInputSourceName} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Target Path</label>
                        		<input class="form-control input-xlarge col-sm-8" id="targetPortalId" value={this.state.targetPortalId} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Image Source</label>
                        		<input class="form-control input-xlarge col-sm-8" id="imageSourcePath" value={this.state.imageSourcePath} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Image Target</label>
                        		<input class="form-control input-xlarge col-sm-8" id="imageTargetPath" value={this.state.imageTargetPath} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Effective On</label>
                        		<input class="form-control input-xlarge col-sm-8" id="effectiveDate" value={this.state.effectiveDate} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Expires On</label>
                        		<input class="form-control input-xlarge col-sm-8" id="expirationDate" value={this.state.expirationDate} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Portal Xfer Mode</label>
                        		<input class="form-control input-xlarge col-sm-8" id="portalXferMode" value={this.state.portalXferMode} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Username</label>
                        		<input class="form-control input-xlarge col-sm-8" id="username" value={this.state.username} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Password</label>
                        		<input class="form-control input-xlarge col-sm-8" id="password" value={this.state.password} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Server</label>
                        		<input class="form-control input-xlarge col-sm-8" id="portalServer" value={this.state.portalServer} onChange={this.handleChange} />
	 			</div>
				<h5>Social</h5>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Votes</label>
                        		<input class="form-control input-xlarge col-sm-8" id="votes" value={this.state.votes} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Content</label>
                        		<input class="form-control input-xlarge col-sm-8" id="contentId" value={this.state.contentId} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Content List</label>
                        		<input class="form-control input-xlarge col-sm-8" id="contentList" value={this.state.contentList} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Picture</label>
                        		<input class="form-control input-xlarge col-sm-8" id="pictureFilepath" value={this.state.pictureFilepath} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Start Date</label>
                        		<input class="form-control input-xlarge col-sm-8" id="startDate" value={this.state.startDate} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">End Date</label>
                        		<input class="form-control input-xlarge col-sm-8" id="endDate" value={this.state.endDate} onChange={this.handleChange} />
	 			</div>

				<h5>API Management</h5>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">API Key</label>
                        		<input class="form-control input-xlarge col-sm-8" id="apiKey" value={this.state.apiKey} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">API Secret</label>
                        		<input class="form-control input-xlarge col-sm-8" id="apiSecret" value={this.state.apiSecret} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Version</label>
                        		<input class="form-control input-xlarge col-sm-8" id="version" value={this.state.version} onChange={this.handleChange} />
	 			</div>
				<div class="form-group row">
		   			<label  class="ContentTitle col-sm-2" value="Name: ">Cloud</label>
                        		<input class="form-control input-xlarge col-sm-8" id="cloudName" value={this.state.cloudName} onChange={this.handleChange} />
	 			</div>

				<hr />
			
   				<div class="form-group row" >
					&nbsp;&nbsp;
   					<button value="Save" class="btn btn-success" onClick={this.handleSave }>Create</button>&nbsp;
   					<button value="Clear" class="btn btn-primary" onClick={this.handleClear }>Clear</button>
					
   				</div>

	        </div>
	</div>
	</div>
	</form>
);


}
}

